export default __webpack_public_path__ + "static/Savoroot-aa199323021408652ddcb2d2a38ab6f1.png";